import { useLocation } from "react-router-dom";
import TicketDetail from "ticket-detail";

export default function TicketDetailHome() {
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  const id = Number(query.get("id"));
  return <TicketDetail id={id} />;
}
